import React from "react";
import { Link } from "react-router-dom";

export const FormActions = ({ isSubmitting, onSubmit, t }) => {
  return (
    <div className="kt-portlet__foot">
      <div className="kt-form__actions">
        {!isSubmitting ? (
          <button type="submit" onClick={onSubmit} className="btn btn-primary">
            {t("Modifier")}
          </button>
        ) : (
          <button
            className="btn btn-primary kt-spinner kt-spinner--left kt-spinner--md kt-spinner--light"
            type="button"
            disabled
          >
            {t("Chargement")}...
          </button>
        )}

        <Link
          to="/dashbord"
          className="btn btn-secondary mx-2"
          style={isSubmitting ? { pointerEvents: "none", opacity: 0.6 } : {}}
        >
          {t("Quitter")}
        </Link>
      </div>
    </div>
  );
};
